import React from 'react';

import { useScrollIndicator } from '@ezbobdev/ui-commons';

import { IndicatorArrows, ScrollIndicator } from './MaterialScrollIndicator.styled';

const MaterialScrollIndicator = ({ thresholdElement }) => {
  const { shouldShowIndicator } = useScrollIndicator(thresholdElement);

  return shouldShowIndicator ? (
    <ScrollIndicator aria-hidden>
      <IndicatorArrows />
    </ScrollIndicator>
  ) : null;
};

export default MaterialScrollIndicator;
